import { render, staticRenderFns } from "./TextCounter.vue?vue&type=template&id=b1e573e2&scoped=true"
import script from "./TextCounter.vue?vue&type=script&lang=js"
export * from "./TextCounter.vue?vue&type=script&lang=js"
import style0 from "./TextCounter.vue?vue&type=style&index=0&id=b1e573e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e573e2",
  null
  
)

export default component.exports